
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">VR游戏中的数字人技术与沉浸式体验</h2>
                    <div class="time">2023-07-14 10:00:10</div>
                    <div class="start">
                        虚拟现实（VR）游戏已成为一种受欢迎的娱乐方式，让玩家能够身临其境地探索各种奇幻世界和互动体验。而其中的关键要素之一就是数字人技术的应用。深圳羽迹科技有限公司作为数字人技术的领军企业，为VR游戏提供了逼真的数字人角色和沉浸式的体验。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/212.png" alt="VR游戏中的数字人技术与沉浸式体验" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            数字人技术在VR游戏中的应用使得虚拟角色能够展现出逼真的外貌和丰富的表情动作。通过高度精确的建模和渲染技术，数字人角色的细节、肢体动作和面部表情都能够被准确地再现。这样的技术突破使得玩家能够更好地融入游戏世界，与虚拟人物进行互动并感受到真实的存在感。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            数字人技术的进步为VR游戏带来了更加真实和身临其境的感觉。玩家可以透过VR设备，沉浸于游戏的虚拟环境中，并与数字人角色进行交互。无论是与虚拟人物对话、参与战斗还是解谜，玩家都能够感受到身临其境的体验。数字人技术的高度逼真性和互动性为玩家带来了全新的娱乐体验，让他们能够更加投入和享受游戏的乐趣。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            数字人技术在VR游戏中的应用不仅提升了娱乐体验，还拓展了游戏的可能性。通过数字人技术，游戏开发者可以创造出各种各样的虚拟角色，包括人类、动物、怪物等，为玩家提供多样化的游戏体验。数字人角色的逼真性和个性化也能够增加游戏的情感共鸣和情节发展，使游戏更加引人入胜。
                        </div>
                    </div>



                    <div class="end">
                        总之，VR游戏中的数字人技术为玩家带来了更加真实、沉浸式的体验。深圳羽迹科技有限公司作为数字人技术的引领者，不断推动数字人技术的创新，为VR游戏开发者提供先进的解决方案。随着数字人技术的不断进步，我们相信VR游戏将会在未来继续发展，并为玩家带来更加精彩和激动人心的游戏体验。
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "VR游戏中的数字人技术与沉浸式体验-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "VR游戏中的数字人技术与沉浸式体验,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "虚拟现实（VR）游戏已成为一种受欢迎的娱乐方式，让玩家能够身临其境地探索各种奇幻世界和互动体验",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo212.vue